<template>
    <div id="sign-up">
        <div class="page animsition text-center sign-up-wrapper" :class="{'vertical-align' : !validation.registrationSuccess}" data-animsition-in="fade-in"
             data-animsition-out="fade-out">
            <div class="page-content" :class="{'vertical-align-middle' : !validation.registrationSuccess}">
                <div style="padding-top: 28px; padding-bottom: 22px;">
                    <a href="http://www.trackado.com"><img class="brand-img" :src="'/Assets/landing/logo-landing.png'" /></a>
                </div>

                <div v-if="!validation.registrationSuccess">
                    <div class="login-page-title">
                        Create your Trackado account
                    </div>
                    <div class="login-page-description">
                        30 days free trial. No credit cards. Cancel anytime.
                    </div>
                    <div v-if="validation.registeredUser">
                        <br /><br />
                        <h4 class="error-message">Email already registered</h4>
                        Great, you already signed-up with this email address!<br />
                        Please go to <a href="../login" class="">Sign In</a> to access your account.<br />
                        Forgot you password? Please click <a href="/Account/ForgotPassword" class="">here</a> to reset your password.<br />
                    </div>
                    <div v-if="validation.invalidEmail">
                        <br /><br />
                        <h4 class="error-message">We couldn't verify this email address at the moment.</h4>
                        Please use a valid, non-temporary email address.<br />
                        Try again with a different email or try again later.<br />
                    </div>
                    <div class="register-form">
                        <form @submit.prevent="onUserRegistration" id="submit-login">
                            <div class="form-group form-material inp-error-marker">
                                <v-input-text :type="text"
                                              :label="'WORK EMAIL'"
                                              :placeholder="'Work Email'"
                                              :value="email"
                                              @input="(val) => (email = val)"
                                              @focus="validation.forEmail = false"
                                              :required="true"
                                              :showError="validation.forEmail"
                                              :errorMessage="emailErrorMsg"></v-input-text>
                                <span class="icon-input-error"></span>
                            </div>

                            <!-- Friendly captcha -->
                            <div id="friendly-captcha"></div>

                            <button v-if="!signUpSubmitted" type="submit" class="btn btn-success btn-block login-btn" id="register-submit-btn" :disabled="!isSubmitBtnDisabled">GET STARTED</button>
                            <button v-else type="button" class="btn btn-success btn-block login-btn" hidden><img class="loader-icon-gif" :src="'/Assets/loader.gif'" /></button>
                        </form>
                    </div>
                    <div class="sign-in-link">
                        Do you already have an account? Please go to <a href="../login" class="">Sign In</a>
                    </div>
                </div>
                <div v-if="validation.registrationSuccess" class="registration-success-content">
                    <div>
                        <div class="check-inbox">
                            <img :src="'/Assets/landing/icon-registration-success.png'" />
                        </div>
                        <div class="success-page-title password-changed">
                            Please check your email<br />
                        </div>
                        <div class="success-page-text password-changed">
                            We have sent an email to <span class="email-receiver bold">{{ email }}</span>.<br />
                        </div>
                        <div class="success-page-text password-changed">
                            Click the link in the email to confirm your address and to set up your account.<br />
                        </div>
                        <div class="success-page-description password-changed">
                            Didn't get the email? <a href="../Account/Registration">Start over</a> to send it again.
                        </div>
                    </div>
                </div>
                <div class="friendly-captcha-login-div-registration">
                    <p>This site is protected by <a href="https://friendlycaptcha.com/" target="_blank">Friendly Captcha</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "sign-up",
        components: {

        },
        props: {},
        data: () => {
            return {
                email: "",
                signUpSubmitted: false,
                emailValidation: false,
                isSubmitBtnDisabled: false,
                emailErrorMsg: "",

                validation: {
                    forEmail: false,
                    registeredUser: false,
                    invalidEmail: false,
                    registrationSuccess: false,
                }
            }
        },
        methods: {
            onUserRegistration() {
                var model = this.getRegistrationData();
                model.CaptchaToken = window.friendlyChallenge.solution;
                this.signUpSubmitted = true;

                if (!this.isValidForm()) {
                    app.api.UserProfile.sendRegisterVerificationEmail(model, this.onRegistrationSucces, this.onRegistrationError);
                }
                else {
                    this.validation.forEmail = true;
                }
            },

            getRegistrationData() {
                var model = app.models.UserRegistrationForVerificationModel();
                model.Email = this.email.trim();
                return model;
            },

            onRegistrationSucces() {
                this.validation.registeredUser = false;
                this.validation.invalidEmail = false;
                this.validation.registrationSuccess = true;
            },

            onRegistrationError(error) {
                this.validation.invalidEmail = false;
                this.validation.registeredUser = false;

                switch (error) {
                    case 'EmailValidationFailed':
                        this.validation.invalidEmail = true;
                        break;

                    case 'EmailAlreadyRegistered':
                        this.validation.registeredUser = true;
                        break;

                    default:
                        app.notifications.showErrorMsg(error);
                }

                this.signUpSubmitted = false;
                window.friendlyChallenge.customWidget.reset();
            },


            isValidForm() {
                var valid = app.Validation;
                var showErrorMsg = false;

                if (this.email == null || this.email == "") {
                    showErrorMsg = true;
                    this.emailErrorMsg = "Please enter your email address";
                    this.signUpSubmitted = false;
                }

                if (!valid.isValidEmailValue(this.email)) {
                    showErrorMsg = true;
                    this.emailErrorMsg = "Please enter a valid email address";
                    this.signUpSubmitted = false;
                }
                return showErrorMsg;
            }
        },
        mounted() {
            $('.sign-up-wrapper').css("-moz-transform", "translatez(0)");
        }
    };
</script>

<style>
    .registration-success-content {
        text-align: center;
        margin-top: 140px;
        padding-bottom: 0px;
    }

    #sign-up {
        height: 100%;
        padding: 0;
        margin: 0 !important;
        background-color: transparent;
    }

        #sign-up .sign-in-link {
            margin-top: 30px !important;
            margin-bottom: 40px;
        }

        #sign-up .register-form {
            margin: 20px auto;
        }

        #sign-up .error-message {
            color: #ee653b;
        }
</style>



// WEBPACK FOOTER //
// SignUpPage.vue?1c34e77e